import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MoneyServices.css';

const MoneyServices = () => {
  const navigate = useNavigate();

  const services = [
    {
      id: 1,
      icon: '💵',
      title: 'Wealth Blueprint & Earning Potential',
      subtitle: 'Discover your financial strengths and natural income sources.',
      features: [
        'Wealth & income astrology reading',
        'Earning capacity analysis',
        'Chart-based prosperity indicators'
      ]
    },
    {
      id: 2,
      icon: '📈',
      title: 'Investment & Risk Forecast',
      subtitle: 'Invest smarter by aligning with planetary cycles.',
      features: [
        'Ideal investment windows',
        'Market & risk analysis through transits',
        'Timing for contracts or big purchases'
      ]
    },
    {
      id: 3,
      icon: '💼',
      title: 'Career–Finance Synergy',
      subtitle: 'Connect your professional path to lasting financial success.',
      features: [
        'Career & wealth alignment',
        'Best timing for income growth',
        'Partnership & side venture insights'
      ]
    },
    {
      id: 4,
      icon: '🧭',
      title: 'Debt, Savings & Financial Stability',
      subtitle: 'Manage money with balance and overcome financial roadblocks.',
      features: [
        'Debt analysis & remedies',
        'Stability forecast',
        'Major purchase or expense timing'
      ]
    },
    {
      id: 5,
      icon: '🌙',
      title: 'Abundance & Prosperity Alignment',
      subtitle: 'Activate your flow of wealth through energetic and astrological alignment.',
      features: [
        'Prosperity mantras & gemstone guidance',
        'Lunar manifestation cycles',
        'Abundance mindset and energy healing'
      ]
    },
    {
      id: 6,
      icon: '🕰️',
      title: 'Annual Financial Forecast',
      subtitle: 'Plan your financial year with precision and planetary guidance.',
      features: [
        'Annual wealth forecast',
        'Transit-based financial planning',
        'Personalized money calendar'
      ]
    }
  ];

  return (
  <section className="bg-sand text-indigoDeep py-8">
      <div className="w-full px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div 
              key={service.id} 
              className="bg-bone/95 text-indigoDeep rounded-xl p-8 border border-gray-200 hover:border-gray-300 transition-all duration-300 hover:transform hover:scale-105 shadow-lg"
            >
              <div className="text-5xl mb-4">{service.icon}</div>
              <h3 className="font-serif text-2xl mb-2 text-indigoDeep">{service.title}</h3>
              <p className="text-grayWarm text-sm mb-6">{service.subtitle}</p>
              
              <div className="space-y-3">
                <p className="text-xs uppercase tracking-widest text-grayWarm font-semibold">Includes:</p>
                <ul className="space-y-2">
                  {service.features.map((feature, index) => (
                    <li key={index} className="flex items-start text-sm text-grayWarm">
                      <span className="text-goldSoft mr-3 mt-1">✦</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <button 
                onClick={() => navigate('/booking')}
                className="w-full mt-8 bg-gradient-to-r from-goldSoft to-goldHover hover:from-goldHover hover:to-goldSoft text-white font-semibold py-3 rounded-lg transition-all duration-300 transform hover:shadow-lg">
                Learn More
              </button>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center bg-white/5 backdrop-blur-md rounded-xl p-12 border border-white/10">
          <p className="text-indigoDeep text-xl mb-8 font-serif">
            Ready to unlock your financial potential through astrology?
          </p>
          <button 
            onClick={() => navigate('/booking')}
            className="bg-gradient-to-r from-goldSoft to-goldHover hover:from-goldHover hover:to-goldSoft text-white font-bold py-4 px-12 rounded-lg hover:shadow-2xl transition-all duration-300 text-lg transform hover:scale-105">
            💰 Schedule Your Wealth Reading
          </button>
        </div>
      </div>
    </section>
  );
};

export default MoneyServices;
